module.exports = __webpack_public_path__ + "static/img/work.2a896da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/work.jpg
// module id = vWMW
// module chunks = 0